import React, {useContext} from 'react';
import {FormFieldItemPropsContext} from '../../../../src/contexts/FormFieldItemPropsContext';
import {useWatch} from 'react-hook-form';
import {IOrderModel} from '../../../../src/@interfaces/models/Order/IOrderModel';
import {IFormFieldItemPropsContext} from '../../../../src/@interfaces/contexts/IFormFieldItemPropsContext';
import ListIcon from '../../../../src/components/List/ListIcon';
import StatusColorListIndicator from '../StatusColorListIndicator';
import {UserContext} from '../../../../src/contexts/UserContext';
import {getCssVarValue} from '../../../../src/helpers/getCssVarValue';
import {isAttentionRequired} from './isAttentionRequired';

export default function CellBeforeTableRestColumns({rowIndex}: { rowIndex: number }) {
    const {
        control,
        fieldName,
        model,
        modelOptions
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};
    const userContext = useContext(UserContext);
    const products = useWatch({control, name: fieldName as 'products'});

    const currentProduct = model?.[fieldName as 'products']?.[rowIndex];
    const currentStatus = (() => {
        const statusId = products?.[rowIndex]?.status_id;
        if (!statusId) {
            return null;
        }

        const statuses = modelOptions?.productStatuses ?? [];

        return statuses.find(item => item.value === statusId) as any | undefined;
    })();

    const shouldPulse = isAttentionRequired(
            currentStatus,
            currentProduct,
            userContext?.model,
            userContext?.can,
    );

    const statusIndicatorColor = currentStatus?.bg_color ?? 'transparent';

    const departmentIcon = (() => {
        const departmentId = products?.[rowIndex]?.department_id;
        const options = modelOptions?.departments;

        if (!departmentId || !options) {
            return null;
        }

        const department = options.find(({value}) => value === departmentId) as any | undefined;
        if (!department || !department.icon_public_path) {
            return null;
        }

        return <div className="d-flex align-items-center">
            <ListIcon src={department.icon_public_path} alt={department.label}/>
        </div>;
    })();

    return <td className="p-0">
        <StatusColorListIndicator
                color={shouldPulse ? getCssVarValue('--bs-danger', '#f00') : statusIndicatorColor}
                pulse={shouldPulse}
        >
            {departmentIcon}
        </StatusColorListIndicator>
    </td>;
}
